// removed by extract-text-webpack-plugin
module.exports = {"section":"_3XTpv6Wg91s3JdkBjuDaZ4","content__wrapper":"_1vboeqAV6NzxwtpHrgHfLa","face__wrapper":"_2OzXITTXufYJNZ-lnovIQ","title":"_1Nfu-I0hVx7MK8klTPYRdY","links__list":"_1rnJQo_hRQlRsEMzohuPFF","link":"lRV6als2W43N9zWDs5300","about__link":"_2RQONw6Qd7Lh8khGiY4xw5","about__wrapper":"_2mLG3NNJb8F516xHWdVi6I","about__dt":"_1tqiehGTPdL5lQbrJtRBg2","about__dl":"_2g3DPeoNiTrZI4v0HNoZbQ","about__dl__nested":"_1rleEZXmlIeCkOXiE8uZNB","image__background":"moveJuznpjbVxUDmyEIBj"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/About/About.module.css
 ** module id = 226
 ** module chunks = 0
 **/